import { takeLatest, put, all, select } from 'redux-saga/effects'

import { sessionTabsActions as navbarActions } from '@tabeeb/modules/sessionTabs'
import { TabPanel, TabPanelLocation } from '@tabeeb/enums'
import * as galleryActions from '../actions'
import * as actions from '../../classificationAnnotationsPagesTimeline/actions'
import * as selectors from '../../classificationAnnotationsPagesTimeline/selectors'

function* onGalleryAddClassificationAnnotations(action) {
  const isClassificationAnnotationsPagesTimelineOpen = yield select(
    selectors.getIsClassificationAnnotationsPagesTimelineOpen
  )
  const currentPanel = yield select((state) => state.navbar.bottom)

  if (!isClassificationAnnotationsPagesTimelineOpen) {
    yield put(actions.openClassificationAnnotationsTimeline())
  }

  if (currentPanel?.name !== TabPanel.ClassificationAnnotations) {
    yield put(navbarActions.switchPanel({ name: TabPanel.ClassificationAnnotations }, TabPanelLocation.Bottom))
  }
}

function* addClassificationAnnotations() {
  yield all([takeLatest(galleryActions.galleryAddClassificationAnnotations, onGalleryAddClassificationAnnotations)])
}

export default addClassificationAnnotations
